import { EventBus } from './bus'
import { Container } from './container'
import kebabCase from 'lodash/kebabCase'
import Glide from '@glidejs/glide'
import Zoomable from './zoomable'
import FullScreen from './fullscreen'
import { PhoneNumberMaskProcessor } from './processor.phone-numbers'

/**
 * DealerKit WordPress Core
 * 
 * @since 1.0.0
 * @package dealerkit-wp
 */
(function(w,d) {
    const core = w.dealerkitWP = w.dealerkitWP ?? {}

    core.window  = w
    core.events = new EventBus()
    core.container = new Container()
    core.slugify = kebabCase

    w.addEventListener('load', () => {
        // Call any queued requests after the core loads.
        if (typeof w.dkWpQ === 'object' && w.dkWpQ.constructor.name === 'Array') {
            w.dkWpQ.forEach(item => {
                item.call(this, w.dealerkitWP)
            })

            delete w.dkWpQ
        }

        // Fire the loaded event.
        w.dealerkitWP.events.emit('loaded')

        // Wire any back buttons on the page.
        w.document.querySelectorAll('.history-go--1').forEach($el => {
            $el.addEventListener('click', (e) => {
                w.history.go(-1)
                e.preventDefault()
            })
        });

        // Process phone number masking.
        if (w.dkpnmr) {
            const rules = JSON.parse(atob(w.dkpnmr))
            const processor = new PhoneNumberMaskProcessor(w)
            processor.replaceElements(rules, w.document.querySelectorAll('[data-dk-phone-link]'))
        }

        // Cookie Banner
        const cookieBanner = d.querySelector('.dealerkit-cookie-banner')

        if (cookieBanner) {
            if (!w.localStorage.getItem('dk_cookie_accepted')) {
                cookieBanner.classList.add('shown')
            }

            cookieBanner.querySelector('button').addEventListener('click', () => {
                w.localStorage.setItem('dk_cookie_accepted', (new Date()).getTime())
                cookieBanner.classList.remove('shown')
            })
        }
    })

    /**
     * Bind the various classes into the container.
     */
    core.container.singleton('search.service', async () => {
        const imported = await import("./service.search")
        return new imported.SearchService(core.events)
    })

    core.container.bind('search.results.controller', async ({ $container, id, defaultParams = {} }) => {
        return core.container.make('search.service').then(async search => {
            const imported = await import('./controller.search.results')
            return new imported.SearchResultsController(core, search, $container, id, defaultParams)
        })
    })

    core.container.bind('search.pagination.controller', async () => {
        const imported = await import('./controller.search.pagination')
        return new imported.PaginationController(core, w)
    })

    core.container.bind('search.sort.controller', async ({ $container, id }) => {
        const imported = await import('./controller.search.sort')
        return new imported.SortController(core, $container, id)
    })

    core.container.bind('search.filters.controller', async ({ $container, id, filterDefinitions }) => {
        const imported = await import('./controller.search.filters')
        return new imported.SearchFilterController(core, $container, id, filterDefinitions)
    })

    core.container.bind('search.entry.point.controller', async ({ $container, id, priceSearchType = null, type = null }) => {
        const imported = await import('./controller.search.entry-point')
        return new imported.SearchEntryPointController(core, $container, id, priceSearchType, type)
    })
}(window, document))

window.Glide = Glide
window.Zoomable = Zoomable
window.FullScreen = FullScreen